
export const spi_email_status  = {
        'approved': 'Approved',
        'rejected': 'Rejected',
        'pending': 'Pending'
    
}